import { ElasticSearchFacetCounts } from 'types/commons';
import { FormattedOption } from 'types/dictionaries';

export const filterOptions = (
  value: string[] | undefined,
  options: FormattedOption[],
  facets?: ElasticSearchFacetCounts
): FormattedOption[] => {
  if (!facets) return options;

  const allowedValues = new Set([...Object.keys(facets), ...(value ?? [])]);

  return options.filter((option) => allowedValues.has(option.value));
};
